import React from 'react';
import { Redirect } from "react-router-dom";

import Player from '../functions/player';

import { EntitiesArray } from '../components/island';

import { finances } from '../actions/financesArray';
import { powerPlants } from '../actions/powerPlantsArray';
import { upgrades } from '../actions/upgradesArray';

import API from '../functions/api';

export class Restore extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      route: undefined,
      shouldRestore: false,
    };

  }

  componentDidMount() {
    let cookie = Player.getCookie('sessionID');

    this.setState({
        redirectTo: undefined
    });

    const shouldRestore = (!Player.getData('sessionWasRestored') && cookie);

    if (shouldRestore) {
        this.restore(cookie);
    }
  }

  restore(sessionId) {
    // Get data from database to restore.

    window.henkie = Player;

    API.post('/?action=getSession&code=' + encodeURIComponent(sessionId) )
    .then((response) => {


        let dataFromApi = response.data.json;
        if (dataFromApi === null || dataFromApi === undefined) {
          return;
        }
        //console.log(response)
        for(let i = 0; i < EntitiesArray.length; i++) {
            EntitiesArray[i].updateDataValues(dataFromApi[i]);
        }

        // this.state.time = response.data.elapsedTime;
        this.setState({
          time: response.data.elapsedTime,
        })
        Player.storeData('timeLeft', response.data.elapsedTime);
        //console.log(Player.getData('timeLeft'));

        //Updates the finances array
        finances.splice(0, finances.length);
        let parsedFinaces = JSON.parse(response.data.finances);

        for (var i = 0; i < parsedFinaces.length; i++) {
          finances.push(parsedFinaces[i]);
        }

        //Updates the powerPlantsArray
        powerPlants.splice(0, powerPlants.length);
        let parsedPowerPlants = JSON.parse(response.data.powerPlants);
        //console.log(parsedPowerPlants);
        for (var ix = 0; ix < parsedPowerPlants.length; ix++) {
          powerPlants.push(parsedPowerPlants[ix]);
        }
        //console.log('after', powerPlants);

        // Updates the upgradesArray
        upgrades.splice(0, upgrades.length);
        let parsedUpgrades = JSON.parse(response.data.upgrades);

        for (var iy = 0; iy < parsedUpgrades.length; iy++) {
          upgrades.push(parsedUpgrades[iy]);
        }

      // We set playerTime to the round times (for GameInfo).
      const time = response.data.elapsedTime;
      const roundLengthsMinusCurrentRoundLength = response.data.roundLengths.slice();
      if (time && typeof time === 'object') {
          roundLengthsMinusCurrentRoundLength[time.part] = Math.max(time.minutes, 0);

          Player.storeData('gameTime', roundLengthsMinusCurrentRoundLength);
          Player.storeData('partOfGame', time.part);

          if (time.part === 4 || time.part === 8) {
            Player.storeData('roundSwitch', true);
          }
          Player.storeData('round', time.round);
          Player.storeData('sessionWasRestored', true);
          if( (time.part === 12 || time.part === "12") && time.minutes === 0){
            this.setState({
                redirectTo: "/endscore",
            });
          } else {
            this.setState({
              redirectTo: time.route,
            });
          }
      }
    });
  }

  render() {
    if (this.state.redirectTo) {
        return (<Redirect to={{
            pathname: '/refresh',
            state: {
                redirectTo: this.state.redirectTo
            }
        }} />);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/restore.js